<template>
  <section class="mdc-card-media mdc-card__media mdc-card__media--16-9"
            :style="'background-image: url(' + src + ')'">
    <div class="mdc-card__media-content">
      <slot/>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    src: String
  }
}
</script>
